import { jsx as _jsx } from "react/jsx-runtime";
import { useState } from 'react';
import { TagInput } from '@wit-support/ui';
/** Имя для показа: «Покупатели 180 (покупатели)»; без имени — «Аудитория 123…». */
export const audienceLabel = (o) => {
    const name = o.name !== null && o.name !== '' ? o.name : `Аудитория ${o.id}`;
    return o.slot !== null && o.slot !== '' ? `${name} · ${o.slot}` : name;
};
/**
 * Выбор аудиторий ПО ID (живая правка кампании, S2): в Meta уходят id, человеку показаны имя и
 * подпись слота. В отличие от `AudienceSlotsWidget` (имена слотов шаблона) нового имени здесь
 * не создать — только выбрать из `options`.
 */
export function AudienceIdsWidget(p) {
    const [query, setQuery] = useState('');
    const q = query.trim().toLocaleLowerCase('ru-RU');
    const byId = new Map(p.options.map((o) => [o.id, o]));
    const suggestions = p.options
        .filter((o) => !p.value.includes(o.id))
        .filter((o) => q === '' || audienceLabel(o).toLocaleLowerCase('ru-RU').includes(q) || o.id.startsWith(q))
        .map((o) => ({ id: o.id, name: audienceLabel(o) }));
    return (_jsx(TagInput, { identity: "id", allowCreate: false, "aria-label": p['aria-label'], value: [...p.value], getLabel: (id) => {
            const o = byId.get(id);
            return o ? audienceLabel(o) : `Аудитория ${id}`;
        }, suggestions: suggestions, query: query, onQueryChange: setQuery, disabled: p.disabled === true, placeholder: p.placeholder ?? 'Найти аудиторию…', maxTags: p.maxTags ?? 50, emptyLabel: "\u041F\u043E\u0434\u0445\u043E\u0434\u044F\u0449\u0438\u0445 \u0430\u0443\u0434\u0438\u0442\u043E\u0440\u0438\u0439 \u043D\u0435\u0442", onChange: (ids) => p.onChange(ids) }));
}
//# sourceMappingURL=audience-ids-widget.js.map